import { render } from "./StockPicking.vue?vue&type=template&id=770ffd04&scoped=true"
import script from "./StockPicking.vue?vue&type=script&lang=js"
export * from "./StockPicking.vue?vue&type=script&lang=js"

import "./StockPicking.vue?vue&type=style&index=0&id=770ffd04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770ffd04"]])

export default __exports__